import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEYS = { admin: "fanene_admin_token", family: "fanene_family_token", checkin: "fanene_checkin_token" };

export const getToken = (kind) => localStorage.getItem(KEYS[kind]);
export const setToken = (kind, value) =>
  value ? localStorage.setItem(KEYS[kind], value) : localStorage.removeItem(KEYS[kind]);

export const pub = axios.create({ baseURL: API });

export function client(kind) {
  const token = getToken(kind);
  const c = axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (kind === "admin") {
    c.interceptors.response.use(undefined, (err) => {
      if (err.response?.status === 401) {
        setToken("admin", null);
        window.location.assign("/organizer/login");
      }
      return Promise.reject(err);
    });
  }
  return c;
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${x.loc?.slice(-1)[0] || ""}: ${x.msg}` : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const photoUrl = (id) => `${API}/photos/${id}/image`;

export function useOverview() {
  return useQuery({ queryKey: ["overview"], queryFn: () => pub.get("/public/overview").then((r) => r.data) });
}
